module.exports = __webpack_public_path__ + "img/file-earmark-slides-fill.8f41eec0.svg";